<!--
 * @Author: zl
 * @Date: 2022-09-15 16:01:24
 * @LastEditTime: 2022-09-16 17:18:44
 * @LastEditors: zl
 * @Description: 审计报告
-->
<template>
	<div class='Report-layout'>
		<el-row>
			<el-col :span="22"
					:offset="1">
				<h2 class="text-center mb30">报 告</h2>
				<el-descriptions :column="2"
								 size="small"
								 border
								 class="custom-descriptions">
					<el-descriptions-item label="工程项目名称"
										  :span="2">{{ currentObj.proName }}</el-descriptions-item>
					<el-descriptions-item label="关联审计任务"
										  :span="2">{{ form.taskName }}</el-descriptions-item>
					<el-descriptions-item label="报告名称"
										  :span="2">{{ form.sname }}</el-descriptions-item>
					<el-descriptions-item label="报告号"
										  :span="2">{{ form.reportNo }}</el-descriptions-item>
					<el-descriptions-item label="报告日期"
										  :span="2">
						{{ form.reportDate ? form.reportDate.substr(0, 10) : '' }}
					</el-descriptions-item>
					<el-descriptions-item label="送审金额 (元)">{{ form.submitAmount }}</el-descriptions-item>
					<el-descriptions-item label="审定金额 (元)">{{ form.auditAmount }}</el-descriptions-item>
					<el-descriptions-item label="审增金额 (元)">{{ form.increAmount }}</el-descriptions-item>
					<el-descriptions-item label="审减金额 (元)">{{ form.reduceAmount }}</el-descriptions-item>
					<el-descriptions-item label="净审减金额 (元)">{{ form.netAmount }}</el-descriptions-item>
					<el-descriptions-item label="甩项金额 (元)">{{ form.jiltAmount }}</el-descriptions-item>
					<el-descriptions-item label="报告内容"
										  :span="2"
										  contentClassName="h200">
						<div class="quill-editor editor w100">
							<div class="ql-container">
								<div class="ql-editor">
									<div class="content"
										 v-html="form.content"></div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item label="上传附件"
										  :span="2">
						<myUpload listType="list"
								  ref="reportUpload"
								  tableName="audit_report"
								  uploadType="2"
								  assortment="test3"
								  width="auto"
								  height="auto"
								  :aid="form.id"
								  mode="view"
								  class="h100 w100"></myUpload>
					</el-descriptions-item>
				</el-descriptions>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import * as API from '@/api/AuditReport/AuditReport'
export default {
	props: {
		currentObj: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	components: {},
	data() {
		return {
			form: {},
		}
	},
	created() {
		// 获取详情
		this.getDetails()
	},
	mounted() {},
	methods: {
		// 获取详情
		getDetails() {
			API.selAuditReportDetail({
				id: this.currentObj.id,
			}).then((res) => {
				this.form = res.data
			})
		},
	},
	computed: {},
}
</script>

<style lang='less' scoped>
</style>